export const legalUpdated = "Outubro de 2026";

export const privacyPolicy = {
  title: "Política de Privacidade",
  intro:
    "A Porta31 Condomínios respeita a sua privacidade e assume o compromisso de proteger os dados pessoais que nos são confiados. Esta Política de Privacidade explica de forma clara que dados recolhemos, para que fins os utilizamos e quais são os seus direitos, em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD).",
  sections: [
    {
      heading: "1. Responsável pelo tratamento",
      paragraphs: [
        "O responsável pelo tratamento dos dados pessoais recolhidos através deste website e da atividade de gestão de condomínios é a Porta31 Condomínios, com atividade em Vila Nova de Famalicão, Portugal.",
        "Para qualquer questão relacionada com a proteção de dados, pode contactar-nos através do email porta31condominios@gmail.com ou pelo telefone +351 917 097 085.",
      ],
    },
    {
      heading: "2. Que dados pessoais recolhemos",
      paragraphs: [
        "Recolhemos apenas os dados necessários para prestar os nossos serviços de gestão de condomínios e para responder aos pedidos de contacto:",
        "Dados de identificação e contacto: nome, email, telefone e endereço do condomínio ou imóvel.",
        "Dados relativos à gestão do condomínio: informação sobre frações, quotas, fornecedores e comunicações entre condóminos.",
        "Dados de navegação: informação técnica agregada e anónima sobre a utilização do website, como páginas visitadas e tipo de dispositivo.",
      ],
    },
    {
      heading: "3. Finalidades e fundamentos jurídicos",
      paragraphs: [
        "Tratamos os seus dados pessoais para as seguintes finalidades: responder a pedidos de reunião e de contacto; prestar serviços de gestão de condomínios; cumprir obrigações legais e contabilísticas; e melhorar a experiência de utilização do website.",
        "Os fundamentos jurídicos do tratamento são a execução de contrato ou de diligências pré-contratuais, o cumprimento de obrigações legais, o interesse legítimo na gestão do condomínio e, quando aplicável, o seu consentimento.",
      ],
    },
    {
      heading: "4. Prazo de conservação dos dados",
      paragraphs: [
        "Conservamos os dados pessoais apenas pelo período necessário ao cumprimento das finalidades que motivaram a sua recolha, ou durante os prazos legalmente exigidos, designadamente os prazos de conservação de documentos fiscais e contabilísticos.",
        "Findo esse período, os dados são eliminados ou anonimizados de forma segura.",
      ],
    },
    {
      heading: "5. Partilha de dados com terceiros",
      paragraphs: [
        "Não vendemos nem cedemos os seus dados pessoais a terceiros para fins comerciais. Os seus dados podem ser partilhados com prestadores de serviços que nos apoiam na gestão do condomínio, como contabilistas, seguradoras, empresas de manutenção e fornecedores de serviços digitais, sempre no estrito cumprimento das obrigações legais e contratuais.",
        "Quando recorremos a prestadores que tratam dados por nossa conta, exigimos garantias adequadas de segurança e confidencialidade.",
      ],
    },
    {
      heading: "6. Os seus direitos",
      paragraphs: [
        "Enquanto titular dos dados, tem o direito de aceder, corrigir, atualizar, limitar, opor-se ao tratamento e solicitar a eliminação dos seus dados pessoais, bem como o direito à portabilidade e a retirar o seu consentimento a qualquer momento.",
        "Para exercer estes direitos, basta enviar-nos um pedido para porta31condominios@gmail.com. Tem também o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD).",
      ],
    },
    {
      heading: "7. Segurança dos dados",
      paragraphs: [
        "Adotamos medidas técnicas e organizativas adequadas para proteger os dados pessoais contra acesso não autorizado, perda, alteração ou divulgação indevida. Ainda assim, nenhum sistema é totalmente inviolável, pelo que recomendamos que nunca partilhe dados sensíveis por canais não seguros.",
      ],
    },
    {
      heading: "8. Alterações a esta política",
      paragraphs: [
        "Esta Política de Privacidade pode ser atualizada sempre que necessário para refletir alterações legais ou de funcionamento dos nossos serviços. A versão em vigor estará sempre disponível nesta página, com indicação da data da última atualização.",
      ],
    },
  ],
};

export const termsConditions = {
  title: "Termos e Condições",
  intro:
    "Estes Termos e Condições regulam a utilização deste website e a prestação de serviços de gestão de condomínios pela Porta31 Condomínios. Ao navegar neste website ou ao contratar os nossos serviços, o utilizador declara ter lido, compreendido e aceite as condições aqui descritas.",
  sections: [
    {
      heading: "1. Objeto e aceitação",
      paragraphs: [
        "O presente website tem como objetivo apresentar a atividade da Porta31 Condomínios e permitir que os interessados solicitem informações, reuniões e propostas de gestão de condomínios.",
        "A aceitação destes Termos e Condições é considerada efetuada no momento da utilização do website ou da submissão de qualquer pedido de contacto.",
      ],
    },
    {
      heading: "2. Serviços prestados",
      paragraphs: [
        "A Porta31 Condomínios presta serviços de administração e gestão de condomínios, incluindo gestão administrativa e financeira, manutenção e conservação, preparação e condução de assembleias de condóminos e apoio jurídico na mediação de conflitos.",
        "As condições específicas de cada prestação de serviços são definidas em proposta e contrato próprios, acordados individualmente com cada condomínio.",
      ],
    },
    {
      heading: "3. Obrigações do utilizador",
      paragraphs: [
        "O utilizador compromete-se a fornecer informações verdadeiras, completas e atualizadas nos formulários deste website e a não utilizar o site para fins ilícitos ou contrários ao presente documento.",
        "O utilizador é responsável pela exatidão dos dados que nos transmite, nomeadamente dados de contacto e informações relativas ao condomínio.",
      ],
    },
    {
      heading: "4. Honorários e condições de pagamento",
      paragraphs: [
        "Os honorários da Porta31 Condomínios são acordados previamente com cada condomínio e podem assumir a forma de valor fixo mensal ou de percentagem sobre o orçamento do condomínio, conforme a proposta apresentada.",
        "Os valores, prazos e condições de faturação constam do contrato celebrado com cada condomínio, prevalecendo sempre o acordado nesse documento.",
      ],
    },
    {
      heading: "5. Propriedade intelectual",
      paragraphs: [
        "Todos os conteúdos deste website, incluindo textos, imagens, logótipos, design e elementos gráficos, são propriedade da Porta31 Condomínios ou dos seus licenciantes e estão protegidos pelas leis de propriedade intelectual.",
        "É proibida a reprodução, distribuição ou utilização dos conteúdos sem autorização prévia e escrita da Porta31 Condomínios.",
      ],
    },
    {
      heading: "6. Limitação de responsabilidade",
      paragraphs: [
        "A informação disponibilizada neste website tem carácter informativo e não constitui, por si só, aconselhamento jurídico ou financeiro. A Porta31 Condomínios esforça-se por manter os conteúdos corretos e atualizados, mas não garante a ausência de erros ou omissões.",
        "A Porta31 Condomínios não é responsável por eventuais danos resultantes da utilização indevida do website ou da interpretação autónoma das informações aqui publicadas.",
      ],
    },
    {
      heading: "7. Alterações aos termos",
      paragraphs: [
        "A Porta31 Condomínios reserva-se o direito de alterar, a qualquer momento, os presentes Termos e Condições, sendo as alterações refletidas nesta página com a data da última atualização.",
      ],
    },
    {
      heading: "8. Lei aplicável e foro competente",
      paragraphs: [
        "Os presentes Termos e Condições regem-se pela lei portuguesa. Para a resolução de qualquer litígio emergente da sua interpretação ou aplicação, é competente o tribunal territorialmente competente de Vila Nova de Famalicão, com expressa renúncia a qualquer outro.",
      ],
    },
  ],
};

export const cookiePolicy = {
  title: "Política de Cookies",
  intro:
    "Este website utiliza cookies para garantir o seu correto funcionamento e para melhorar a experiência de navegação. Esta Política de Cookies explica o que são cookies, que tipos utilizamos e como pode geri-los no seu navegador.",
  sections: [
    {
      heading: "1. O que são cookies",
      paragraphs: [
        "Os cookies são pequenos ficheiros de texto que são guardados no dispositivo do utilizador quando visita um website. Permitem que o site se lembre das suas preferências e recolha informação estatística agregada sobre a utilização das páginas.",
      ],
    },
    {
      heading: "2. Como utilizamos os cookies",
      paragraphs: [
        "Utilizamos cookies para assegurar o funcionamento básico do website, recordar preferências de navegação e recolher estatísticas anónimas que nos ajudam a compreender como o site é utilizado e a melhorá-lo continuamente.",
      ],
    },
    {
      heading: "3. Tipos de cookies que utilizamos",
      paragraphs: [
        "Cookies essenciais: necessários ao funcionamento do website e à segurança da navegação. Sem estes cookies, algumas funcionalidades não podem ser asseguradas.",
        "Cookies de desempenho: recolhem informação anónima e agregada sobre a forma como os visitantes utilizam o site, ajudando-nos a melhorar o seu desempenho.",
        "Cookies de funcionalidade: permitem recordar as escolhas do utilizador, como idioma ou preferências de visualização, proporcionando uma experiência mais personalizada.",
      ],
    },
    {
      heading: "4. Cookies de terceiros",
      paragraphs: [
        "Alguns serviços integrados neste website, como ferramentas de estatística ou plataformas de redes sociais, podem instalar os seus próprios cookies. A utilização desses cookies é regida pelas políticas de privacidade dos respetivos fornecedores.",
      ],
    },
    {
      heading: "5. Como gerir os cookies",
      paragraphs: [
        "Pode, a qualquer momento, configurar o seu navegador para bloquear ou eliminar cookies, bem como para o alertar sempre que um cookie é instalado. Cada navegador disponibiliza essa gestão nas suas opções ou definições de privacidade.",
        "Tenha em atenção que a desativação de determinados cookies pode afetar o funcionamento correto do website e limitar algumas funcionalidades.",
      ],
    },
    {
      heading: "6. Alterações a esta política",
      paragraphs: [
        "Esta Política de Cookies pode ser atualizada periodicamente para refletir alterações técnicas, legais ou de funcionamento do website. Recomendamos a consulta regular desta página para se manter informado.",
      ],
    },
  ],
};